<template>
    <nav class="nav">
        <div class="nav-content">
            <div class="logo logo1">
                <!-- <img src="@/assets/img/header-logo.png" alt=""> -->
                <img src="@/assets/img/lg-logo.png" alt="" />
            </div>
            <div class="nav-title">
                <p>
                    <span class="text-bold openSans"
                        >LGPD - Lei Geral de Proteção de Dados Pessoais</span
                    >
                </p>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    props: ["scrolled"],
    data() {
        return {
            fontSizeUpdated: 16,
            fontsize: 0,
            size: null,
        };
    },
    methods: {
        openNav() {
            // console.log("OPEN NAV");
            document.getElementById("mobile__menu").style.width = "100%";
        },
        closeNav() {
            // console.log("CLOSE NAV");
            document.getElementById("mobile__menu").style.width = "0";
        },
        scrollNav() {
            if (window.pageYOffset > 0) {
                this.scrolled = true;
            } else {
                this.scrolled = false;
            }
        },
    },
    created() {
        if (
            navigator.userAgent.indexOf("MSIE") !== -1 ||
            navigator.appVersion.indexOf("Trident/") > -1
        ) {
            window.addEventListener("scroll", this.scrollNav);
        }
    },
};
</script>

<style lang="scss" scoped>
.bgactive {
    background: none white !important;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.3);
}
.nav {
    font-size: 17px;
    transition: 0.5s;
    position: absolute;
    width: 100%;
    height: 80px;
    // background: rgb(0,0,0);
    // background: linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%);
    background: none white !important;

    &-content {
        position: relative;
        transition: 0.5s;
        //height: 100%;
        height: 80px;
        margin: 0 auto;
        max-width: 1366px;
        display: flex;
        flex-direction: row;
        //grid-template-columns: repeat(2, 1fr);
        justify-items: stretch;
        align-items: center;

        //text-align: center;
        .logo {
            margin-left: 117px;

            img {
                margin-bottom: 15px;
            }
        }
        .nav-title {
            width: 100%;
            transition: 0.5s;
            justify-self: end;
            margin-right: 117px;
            // font-size: 16px;
            text-align: right;
        }
    }
    &-right {
        height: 63px;
        &-textos {
            padding-left: 10px;
            position: absolute;
            right: 50px;
            //top: 50%;
            //transform: translateY(-50%);
            //font-size: 0.8rem;
            font-size: 14px;
            color: rgb(255, 255, 255);
            display: inline-block;
            p {
                margin: 0;
            }
            a {
                color: rgba(255, 255, 255, 1) !important;
                text-decoration: none;
                display: inline-block;
                //padding-top: 5px;
            }
            .round-btn {
                margin-top: 5px;
                line-height: 20px;
                position: relative;
                cursor: pointer;
                //font-size: 1rem;
                font-size: 17px;
                width: 36px;
                height: 28px;
                border-radius: 40px;
                border: 1px solid;
                border-color: rgba(255, 255, 255, 0.6);
                &-text {
                    line-height: 35px;
                    height: 38px;
                }
            }
            .contrast-btn {
                padding-top: 8px;
            }
        }
        &-textos-alt {
            color: rgba(0, 83, 163, 1);
            a {
                color: rgba(0, 83, 163, 1) !important;
            }
            .round-btn-alt {
                margin-top: 5px;
                line-height: 20px;
                position: relative;
                cursor: pointer;
                //font-size: 1rem;
                font-size: 17px;
                width: 36px;
                height: 28px;
                border-radius: 40px;
                border: 1px solid;
                border-color: rgba(0, 83, 163, 0.2);
                &-text {
                    line-height: 35px;
                    height: 38px;
                }
            }
        }
    }
    &-button {
        display: flex;
        justify-content: center;
        align-items: stretch;
        flex-direction: row;
        .contrast-icon {
            height: 20px;
        }
    }
    @media (max-width: 900px) {
        &-content {
            .logo {
                margin-left: 20px;
                img {
                    max-width: 100%;
                }
            }
            .nav-title {
                margin-right: 20px;
            }
        }
    }
}
</style>